/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherRevocaAnnullamentoForm { 
    /**
     * Motivazione dell\'annullamento della revoca (obbligatoria, testo libero)
     */
    motivo?: string;
    /**
     * Version del voucher letta dal client (optimistic lock)
     */
    version: number;
}

